import fp from "lodash/fp";
import moment from "moment";

import { AmexOptBlueOrEsaTypes } from "types";

export default function mapFeesForm({ ...form } = {} as any) {
	if (fp.isEmpty(form)) return;
	delete form.__validationHack__;
	delete form.__template__;

	const result = {
		...form,
		cardNetworkPerTokenizationEventFee: form.isCardNetworkTokenization
			? form.cardNetworkPerTokenizationEventFee
			: 0,
		cardNetworkTokenizationMonthlyFee: form.isCardNetworkTokenization
			? form.cardNetworkTokenizationMonthlyFee
			: 0,
		cardNetworkTokenizationSetupFee: form.isCardNetworkTokenization
			? form.cardNetworkTokenizationSetupFee
			: 0,
		miscFees: form?.miscFees?.map((mf, index) => {
			return {
				...mf,
				percentage: mf.percentage === "" ? 0 : mf.percentage,
				startDate: moment.utc(mf.startDate, "MM/DD/YYYY").toISOString(),
				endDate: moment.utc(mf.endDate, "MM/DD/YYYY").toISOString(),
				order: index + 1,
			};
		}),
		isMonthEnd: form?.isMonthEnd && JSON?.parse(form?.isMonthEnd),
		discountType: form?.discountType && parseInt?.(form?.discountType),
		amexType: form?.isActiveAmexOptBlueOrEsaSection
			? form?.amexType
			: AmexOptBlueOrEsaTypes.None.value,
	};

	return result;
}
